export default "__VITE_ASSET__DZdn99uK__"